@if (formState$ | async; as formState) {
  <div class="modal-body">
    @if (!formState.success && !formState.error) {
      <form [formGroup]="callbackForm" class="callback-form" action="submit">
        <div class="callback-form__title text-md-h3-s text-h6-s">Заявка</div>
        <sd-input class="callback-form__phone-input" label="номер телефона">
          <input type="tel" formControlName="phone" sdPhoneMaskFix sdPhoneAuthorizedUser />
        </sd-input>

        <sd-input class="callback-form__address" label="адрес объекта">
          <input formControlName="address" />
        </sd-input>

        <div class="callback-form__is-mounted">
          <div class="title text-b3-s-500 text-md-b2-s-500">Смонтирована стропильная часть кровли?</div>
          <div class="radio"><sd-radio formControlName="isRoofTrussMounted" [value]="true">Да</sd-radio></div>
          <div class="radio"><sd-radio formControlName="isRoofTrussMounted" [value]="false">Нет</sd-radio></div>
        </div>
        <div>
          <button
            class="callback-form__submit-btn"
            sdButton
            [disabled]="callbackForm.disabled || !callbackForm.valid"
            [fullWidth]="isMobile$ | async"
            size="l"
            theme="primary"
            (click)="submitForm()"
          >
            Отправить заявку
          </button>
        </div>
        <div class="callback-form__agreement">
          <sd-personal-data-agree-text-callback></sd-personal-data-agree-text-callback>
        </div>
      </form>
    }

    @if (formState.success) {
      <sd-success-msg></sd-success-msg>
    }

    @if (formState.error) {
      <sd-error-msg></sd-error-msg>
    }
  </div>
}
